var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8968_11290)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8968_11290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8968_11290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 19C4.45 19 3.97917 18.8042 3.5875 18.4125C3.19583 18.0208 3 17.55 3 17V10C3 8.76667 3.2375 7.60417 3.7125 6.5125C4.1875 5.42083 4.83333 4.46667 5.65 3.65C6.46667 2.83333 7.42083 2.1875 8.5125 1.7125C9.60417 1.2375 10.7667 1 12 1C13.2333 1 14.3958 1.2375 15.4875 1.7125C16.5792 2.1875 17.5333 2.83333 18.35 3.65C19.1667 4.46667 19.8125 5.42083 20.2875 6.5125C20.7625 7.60417 21 8.76667 21 10V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H13C12.7167 22 12.4792 21.9042 12.2875 21.7125C12.0958 21.5208 12 21.2833 12 21C12 20.7167 12.0958 20.4792 12.2875 20.2875C12.4792 20.0958 12.7167 20 13 20H19V19H17C16.45 19 15.9792 18.8042 15.5875 18.4125C15.1958 18.0208 15 17.55 15 17V13C15 12.45 15.1958 11.9792 15.5875 11.5875C15.9792 11.1958 16.45 11 17 11H19V10C19 8.06667 18.3167 6.41667 16.95 5.05C15.5833 3.68333 13.9333 3 12 3C10.0667 3 8.41667 3.68333 7.05 5.05C5.68333 6.41667 5 8.06667 5 10V11H7C7.55 11 8.02083 11.1958 8.4125 11.5875C8.80417 11.9792 9 12.45 9 13V17C9 17.55 8.80417 18.0208 8.4125 18.4125C8.02083 18.8042 7.55 19 7 19H5ZM5 17H7V13H5V17ZM17 17H19V13H17V17Z",
    fill: "#111111"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8968_11290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/service_icon.0e54e4a6df3237964b204cb9edcb9d26.svg";
export { ForwardRef as ReactComponent };